/* =====================================================================
   SLIDER UTILITY — shared by Previous Projects and New Launches.
   Handles cross-fade slides, prev/next arrows, counter, and keyboard
   navigation. Each slider instance is identified by a data attribute
   on the section wrapper; slide/control data attributes are namespaced
   per slider so the two sliders are fully independent.
   ===================================================================== */
(function () {
    function pad(value) {
        return String(value).length < 2 ? '0' + String(value) : String(value);
    }

    /**
     * @param {Element} slider  — the section wrapper element
     * @param {object}  selectors — data-attribute names specific to this slider
     *   .slide      — selector for slide articles   e.g. '.ah-prev-slide'
     *   .viewport   — data attr on the keyboard target
     *   .prev       — data attr on the "previous" button
     *   .next       — data attr on the "next" button
     *   .current    — data attr on the counter "current" span
     *   .total      — data attr on the counter "total" span
     */
    function initSlider(slider, selectors) {
        var slides = Array.prototype.slice.call(slider.querySelectorAll(selectors.slide));
        if (!slides.length) return;

        var viewport = slider.querySelector('[' + selectors.viewport + ']') || slider;
        var prev     = slider.querySelector('[' + selectors.prev    + ']');
        var next     = slider.querySelector('[' + selectors.next    + ']');
        var current  = slider.querySelector('[' + selectors.current + ']');
        var total    = slider.querySelector('[' + selectors.total   + ']');

        var index = 0;

        function render() {
            slides.forEach(function (slide, i) {
                var active = i === index;
                slide.classList.toggle('is-active', active);
                slide.setAttribute('aria-hidden', String(!active));
            });
            if (current) current.textContent = pad(index + 1);
            if (total)   total.textContent   = pad(slides.length);
        }

        function go(delta) {
            var count = slides.length;
            index = (index + delta + count) % count;
            render();
        }

        if (prev) prev.addEventListener('click', function () { go(-1); });
        if (next) next.addEventListener('click', function () { go(1);  });

        viewport.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft'  || e.key === 'Left')  { e.preventDefault(); go(-1); }
            if (e.key === 'ArrowRight' || e.key === 'Right') { e.preventDefault(); go(1);  }
        });

        render();
    }

    function init() {
        /* ── Previous Projects slider ── */
        var prevSliders = document.querySelectorAll('[data-ah-project-slider]');
        Array.prototype.forEach.call(prevSliders, function (slider) {
            initSlider(slider, {
                slide:    '.ah-prev-slide',
                viewport: 'data-ah-project-viewport',
                prev:     'data-ah-project-prev',
                next:     'data-ah-project-next',
                current:  'data-ah-project-current',
                total:    'data-ah-project-total',
            });
        });

        /* ── New Launches slider ── */
        var launchSliders = document.querySelectorAll('[data-ah-launch-slider]');
        Array.prototype.forEach.call(launchSliders, function (slider) {
            initSlider(slider, {
                slide:    '.ah-launch-slide',
                viewport: 'data-ah-launch-viewport',
                prev:     'data-ah-launch-prev',
                next:     'data-ah-launch-next',
                current:  'data-ah-launch-current',
                total:    'data-ah-launch-total',
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
